module.exports = {
  title: '信息管理平台',
  base_title: '基础信息管理系统',
  lab_title: '实验室检测管理系统',
  oa_title: '资源综合管理系统',
  hr_title: '人事管理系统',
  stock_title: '库存管理系统',
  budget_title: '资金预算管理系统',
  // adm_title: '行政管理系统',
  purchase_title: '采购管理系统',

  /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   */
  showSettings: true,

  /**
   * @type {boolean} true | false
   * @description Whether need tagsView
   */
  tagsView: true,

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false,

  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  errorLog: 'production'
}
